// extracted by mini-css-extract-plugin
export default {"main_container":"Break_main_container__eCz9o","writeHelperTool":"Break_writeHelperTool__wtn6n","news":"Break_news__xVpyx"};